module.exports = __webpack_public_path__ + "img/xmas_item_h.998321ad.jpg";